import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'lib-empty-list-placeholder',
  templateUrl: './empty-list-placeholder.component.html',
  styleUrls: ['./empty-list-placeholder.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslocoModule, RouterModule],
})
export class EmptyListPlaceholderComponent {
  @Output() btnClick = new EventEmitter<void>();
  @Input() labelText = 'global.empty_list';
  @Input() btnText = 'global.go_to';

  handleClick() {
    this.btnClick.emit();
  }
}
